import {charcoal} from '../sass/base/_exports.sass';

export const FiltersIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 17;
  const height = 17;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.5C8.27614 3.5 8.5 3.27614 8.5 3C8.5 2.72386 8.27614 2.5 8 2.5C7.72386 2.5 7.5 2.72386 7.5 3C7.5 3.27614 7.72386 3.5 8 3.5ZM8 4.5C7.34689 4.5 6.79127 4.0826 6.58535 3.5H3C2.72386 3.5 2.5 3.27614 2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H6.58535C6.79127 1.9174 7.34689 1.5 8 1.5C8.82843 1.5 9.5 2.17157 9.5 3C9.5 3.82843 8.82843 4.5 8 4.5ZM14 3.5C14.2761 3.5 14.5 3.27614 14.5 3C14.5 2.72386 14.2761 2.5 14 2.5H11C10.7239 2.5 10.5 2.72386 10.5 3C10.5 3.27614 10.7239 3.5 11 3.5H14ZM6 13.5C6.27614 13.5 6.5 13.2761 6.5 13C6.5 12.7239 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.7239 5.5 13C5.5 13.2761 5.72386 13.5 6 13.5ZM6 14.5C5.34689 14.5 4.79127 14.0826 4.58535 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13C2.5 12.7239 2.72386 12.5 3 12.5H4.58535C4.79127 11.9174 5.34689 11.5 6 11.5C6.82843 11.5 7.5 12.1716 7.5 13C7.5 13.8284 6.82843 14.5 6 14.5ZM14 13.5C14.2761 13.5 14.5 13.2761 14.5 13C14.5 12.7239 14.2761 12.5 14 12.5H9C8.72386 12.5 8.5 12.7239 8.5 13C8.5 13.2761 8.72386 13.5 9 13.5H14ZM10.5 8C10.5 8.27614 10.2761 8.5 10 8.5C9.72386 8.5 9.5 8.27614 9.5 8C9.5 7.72386 9.72386 7.5 10 7.5C10.2761 7.5 10.5 7.72386 10.5 8ZM8.58535 8.5C8.79127 9.0826 9.34689 9.5 10 9.5C10.8284 9.5 11.5 8.82843 11.5 8C11.5 7.17157 10.8284 6.5 10 6.5C9.34689 6.5 8.79127 6.9174 8.58535 7.5H3C2.72386 7.5 2.5 7.72386 2.5 8C2.5 8.27614 2.72386 8.5 3 8.5H8.58535ZM14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H13C12.7239 8.5 12.5 8.27614 12.5 8C12.5 7.72386 12.7239 7.5 13 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8Z"
        fill={color}
      />
    </svg>
  );
};
